import gql from 'graphql-tag';

import integrationItemFragment from './integrationItemFragment';

export const integrationItemsPageFragment = gql`
  fragment integrationItemsPageFragment on IntegrationItemsPage {
    dokkioClass
    total
    integrationItems {
      ...integrationItemFragment
    }
  }
  ${integrationItemFragment}
`;
export default integrationItemsPageFragment;
